(() => {
  if (window.__alternixQuickBuyInitialised) return;
  window.__alternixQuickBuyInitialised = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let activeTrigger = null;
  let state = null;
  let lockedScrollY = 0;
  let lockedWithFixedBody = false;

  function lockPageScroll() {
    if (document.documentElement.classList.contains('vss-quickbuy-open')) return;

    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    lockedWithFixedBody = window.matchMedia('(max-width: 749px)').matches;
    document.documentElement.classList.add('vss-quickbuy-open');
    document.body.classList.add('vss-quickbuy-open');

    if (lockedWithFixedBody) {
      document.body.style.top = `-${lockedScrollY}px`;
    }
  }

  function unlockPageScroll() {
    const previousScrollBehavior = document.documentElement.style.scrollBehavior;

    if (lockedWithFixedBody) {
      document.documentElement.style.scrollBehavior = 'auto';
    }

    document.documentElement.classList.remove('vss-quickbuy-open');
    document.body.classList.remove('vss-quickbuy-open');
    document.body.style.top = '';

    if (lockedWithFixedBody) {
      window.scrollTo({ top: lockedScrollY, left: 0, behavior: 'auto' });
      requestAnimationFrame(() => {
        document.documentElement.style.scrollBehavior = previousScrollBehavior;
      });
    }

    lockedWithFixedBody = false;
  }

  function createDrawer() {
    if (document.querySelector('[data-vss-quickbuy]')) return;

    const drawer = document.createElement('div');
    drawer.className = 'vss-quickbuy alternix-quickbuy-design';
    drawer.hidden = true;
    drawer.setAttribute('data-vss-quickbuy', '');
    drawer.innerHTML = `
      <div class="vss-quickbuy__backdrop" data-vss-quickbuy-close></div>
      <section class="vss-quickbuy__panel" role="dialog" aria-modal="true" aria-labelledby="vss-quickbuy-title">
        <div class="vss-quickbuy__toolbar">
          <button type="button" class="vss-quickbuy__close" data-vss-quickbuy-close aria-label="Close quick buy">×</button>
        </div>
        <div class="vss-quickbuy__scroll">
        <div class="vss-quickbuy__header">
          <img class="vss-quickbuy__image" data-vss-quickbuy-image alt="">
          <div class="vss-quickbuy__headcopy">
            <h2 class="vss-quickbuy__title" id="vss-quickbuy-title" data-vss-quickbuy-title></h2>
            <div class="vss-quickbuy__meta" data-vss-quickbuy-meta></div>
            <p class="vss-quickbuy__flavour" data-vss-quickbuy-flavour hidden></p>
            <a class="vss-quickbuy__details-link" data-vss-quickbuy-details href="#">
              View product details
            </a>
          </div>
        </div>
        <div class="vss-quickbuy__body">
          <div data-vss-quickbuy-body></div>
        </div>
        </div>
        <div class="vss-quickbuy__footer">
          <div class="vss-quickbuy__summary">
            <span data-vss-quickbuy-summary></span>
            <strong data-vss-quickbuy-total></strong>
          </div>
          <button type="button" class="vss-quickbuy__submit" data-vss-quickbuy-submit>Add to basket</button>
        </div>
      </section>
    `;
    document.body.appendChild(drawer);
  }

  function getDrawer() {
    createDrawer();
    return document.querySelector('[data-vss-quickbuy]');
  }

  function parsePackOptions(raw, unit) {
    if (!raw) return [];
    return raw.split('|').map((item) => {
      const [quantity, total, each] = item.split('~');
      return {
        quantity: Number(quantity),
        total: Number(total),
        each: Number(each),
        unit
      };
    }).filter((item) => item.quantity && Number.isFinite(item.total) && Number.isFinite(item.each));
  }

  function money(value) {
    return `£${Number(value).toFixed(2)}`;
  }

  function optionLabel(quantity, unit) {
    return `${quantity} ${unit}${quantity === 1 ? '' : 's'}`;
  }

  function savingPercent(baseEach, each) {
    if (!baseEach || !each || each >= baseEach) return 0;
    return Math.round((1 - (each / baseEach)) * 100);
  }

  function cartQuantityForVariant(cart, variantId) {
    return (cart.items || []).reduce((total, item) => {
      const itemVariantId = Number(item.variant_id || item.id);
      return itemVariantId === variantId ? total + Number(item.quantity || 0) : total;
    }, 0);
  }

  async function remainingStockForVariant(variantId, inventoryStock) {
    try {
      const cart = await getCart();
      return Math.max(0, inventoryStock - cartQuantityForVariant(cart, variantId));
    } catch (error) {
      console.warn('Unable to account for basket quantity while checking stock.', error);
      return inventoryStock;
    }
  }

  function clampSingleQuantity(value) {
    const parsed = Math.floor(Number(value));
    const quantity = Number.isFinite(parsed) ? Math.max(1, parsed) : 1;
    return state.stockEnforced
      ? Math.min(quantity, Math.max(1, state.availableStock))
      : quantity;
  }

  function updateSingleQuantityUI(drawer) {
    const summary = drawer.querySelector('[data-vss-quickbuy-summary]');
    const totalTarget = drawer.querySelector('[data-vss-quickbuy-total]');
    const submit = drawer.querySelector('[data-vss-quickbuy-submit]');
    const quantityInput = drawer.querySelector('[data-vss-quickbuy-quantity]');
    const minus = drawer.querySelector('[data-vss-quickbuy-minus]');
    const plus = drawer.querySelector('[data-vss-quickbuy-plus]');
    const unavailable = state.stockEnforced && state.quantity > state.availableStock;

    if (quantityInput && quantityInput.value !== String(state.quantity)) {
      quantityInput.value = state.quantity;
    }

    if (quantityInput) {
      quantityInput.disabled = state.stockEnforced && state.availableStock < 1;
      if (state.stockEnforced) quantityInput.max = state.availableStock;
    }

    if (minus) minus.disabled = state.quantity <= 1;
    if (plus) plus.disabled = state.stockEnforced && state.quantity >= state.availableStock;

    summary.textContent = `${state.quantity} item${state.quantity === 1 ? '' : 's'}`;
    totalTarget.textContent = money(state.unitPrice * state.quantity);
    submit.disabled = unavailable || state.quantity < 1;
    submit.textContent = unavailable
      ? 'Not enough stock'
      : `Add ${optionLabel(state.quantity, state.unit).toLowerCase()} • ${money(state.unitPrice * state.quantity)}`;
  }

  function renderPurchaseUI() {
    const drawer = getDrawer();
    const body = drawer.querySelector('[data-vss-quickbuy-body]');
    const summary = drawer.querySelector('[data-vss-quickbuy-summary]');
    const totalTarget = drawer.querySelector('[data-vss-quickbuy-total]');
    const submit = drawer.querySelector('[data-vss-quickbuy-submit]');
    const optionsScrollTop = drawer.querySelector('[data-vss-quickbuy-options]')?.scrollTop || 0;

    drawer.classList.toggle('is-bulk', state.isBulk);
    drawer.classList.toggle('is-single', !state.isBulk);
    drawer.classList.toggle('is-short-list', state.isBulk && state.options.length === 2);

    if (state.isBulk) {
      const baseEach = state.options[0]?.each || 0;

      body.innerHTML = `
        <div class="vss-quickbuy__eyebrow">Choose number of ${state.unit.toLowerCase()}s</div>
        ${state.stockEnforced
          ? `<div class="vss-quickbuy__stock-note">${state.availableStock} currently available</div>`
          : ''
        }
        <div class="vss-quickbuy__options" data-vss-quickbuy-options></div>
      `;

      const optionsTarget = body.querySelector('[data-vss-quickbuy-options]');

      optionsTarget.innerHTML = state.options.map((option, index) => {
        const saving = savingPercent(baseEach, option.each);
        const unavailable = state.stockEnforced && option.quantity > state.availableStock;

        return `
          <button
            type="button"
            class="vss-quickbuy__option${index === state.selectedIndex ? ' is-selected' : ''}${unavailable ? ' is-unavailable' : ''}"
            data-vss-quickbuy-option="${index}"
            role="radio"
            aria-checked="${index === state.selectedIndex ? 'true' : 'false'}"
            ${unavailable ? 'disabled aria-disabled="true"' : ''}
          >
            <span class="vss-quickbuy__radio" aria-hidden="true"></span>
            <span class="vss-quickbuy__option-main">
              <span class="vss-quickbuy__option-title">${optionLabel(option.quantity, option.unit)}</span>
              <span class="vss-quickbuy__option-sub">
                (${money(option.each)} each)
              </span>
            </span>
            ${unavailable ? `<span class="vss-quickbuy__option-stock">Only ${state.availableStock} available</span>` : `<span class="vss-quickbuy__saving">${saving ? `Save ${saving}%` : ''}</span>`}
            <span class="vss-quickbuy__option-price">${money(option.total)}</span>
          </button>
        `;
      }).join('');

      optionsTarget.scrollTop = optionsScrollTop;

      const selected = state.options[state.selectedIndex];
      const unavailable = state.stockEnforced && selected.quantity > state.availableStock;

      summary.textContent = optionLabel(selected.quantity, selected.unit);
      totalTarget.textContent = money(selected.total);
      submit.disabled = unavailable;
      submit.textContent = unavailable ? 'Not enough stock' : `Add ${optionLabel(selected.quantity, selected.unit).toLowerCase()} • ${money(selected.total)}`;
      return;
    }

    body.innerHTML = `
      <div class="vss-quickbuy__single-price"><strong>${money(state.unitPrice)}</strong> <span>per item</span></div>
      <div class="vss-quickbuy__single-caption">
        <span>Choose how many you'd like</span>
        ${state.stockEnforced ? `<span class="${state.availableStock <= 10 ? 'is-low-stock' : ''}">${state.availableStock} currently available</span>` : ''}
      </div>
      <div class="vss-quickbuy__quantity-control" aria-label="Choose quantity">
        <button type="button" class="vss-quickbuy__quantity-button" data-vss-quickbuy-minus aria-label="Decrease quantity" ${state.quantity <= 1 ? 'disabled' : ''}>−</button>
        <input
          type="number"
          class="vss-quickbuy__quantity-value"
          data-vss-quickbuy-quantity
          value="${state.quantity}"
          min="1"
          ${state.stockEnforced ? `max="${state.availableStock}"` : ''}
          ${state.stockEnforced && state.availableStock < 1 ? 'disabled' : ''}
          step="1"
          inputmode="numeric"
          aria-label="Quantity"
        >
        <button type="button" class="vss-quickbuy__quantity-button" data-vss-quickbuy-plus aria-label="Increase quantity" ${state.stockEnforced && state.quantity >= state.availableStock ? 'disabled' : ''}>+</button>
      </div>
    `;

    updateSingleQuantityUI(drawer);
  }

  async function openDrawer(trigger) {
    const drawer = getDrawer();
    const variantId = Number(trigger.dataset.variantId);
    const isBulk = trigger.dataset.isBulk === 'true';
    const stockEnforced = trigger.dataset.stockEnforced === 'true';
    const inventoryStock = Math.max(0, Number(trigger.dataset.availableStock || 0));
    const availableStock = stockEnforced
      ? await remainingStockForVariant(variantId, inventoryStock)
      : inventoryStock;
    const unitPrice = Math.max(0, Number(trigger.dataset.unitPriceCents || 0)) / 100;

    let options = [];
    let selectedIndex = 0;

    if (isBulk) {
      options = parsePackOptions(
        trigger.dataset.packOptions,
        trigger.dataset.packUnit || 'Can'
      );

      if (!options.length) return;

      selectedIndex = options.findIndex((option) => {
        return !stockEnforced || option.quantity <= availableStock;
      });

      if (selectedIndex < 0) selectedIndex = 0;
    }

    activeTrigger = trigger;
    state = {
      variantId,
      title: trigger.dataset.productTitle || '',
      image: trigger.dataset.productImage || '',
      meta: trigger.dataset.productMeta || '',
      unit: trigger.dataset.packUnit || 'Item',
      url: trigger.dataset.productUrl || '#',
      isBulk,
      options,
      selectedIndex,
      quantity: 1,
      unitPrice,
      stockEnforced,
      inventoryStock,
      availableStock
    };

    drawer.querySelector('[data-vss-quickbuy-title]').textContent = state.title;
    // Presentation only: retain the existing metadata, styling a recognised strength separately.
    const meta = drawer.querySelector('[data-vss-quickbuy-meta]');
    meta.replaceChildren();
    const parts = state.meta.split('·').map(part => part.trim()).filter(Boolean);
    parts.forEach((part, index) => {
      const span = document.createElement('span');
      span.className = index === 0 && /(?:mg|nic(?:otine)?[ -]?free)/i.test(part)
        ? 'vss-quickbuy__strength' : 'vss-quickbuy__pack';
      span.textContent = part;
      meta.appendChild(span);
    });
    // Optional attribute; no product data or purchasing logic is inferred.
    const flavour = drawer.querySelector('[data-vss-quickbuy-flavour]');
    flavour.textContent = trigger.dataset.productFlavour || '';
    flavour.hidden = !flavour.textContent;

    const detailsLink = drawer.querySelector('[data-vss-quickbuy-details]');
    if (detailsLink) detailsLink.href = state.url;

    const image = drawer.querySelector('[data-vss-quickbuy-image]');
    image.src = state.image;
    image.alt = state.title;

    renderPurchaseUI();

    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    lockPageScroll();

    const close = drawer.querySelector('.vss-quickbuy__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-vss-quickbuy]');
    if (!drawer || drawer.hidden) return;

    drawer.classList.remove('is-open');

    window.setTimeout(() => {
      drawer.hidden = true;
      unlockPageScroll();
      if (activeTrigger) activeTrigger.focus();
      activeTrigger = null;
      state = null;
    }, 220);
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh basket.');
    return response.json();
  }

  function updateCartBubble(itemCount) {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    let bubble = cartIcon.querySelector('.cart-count-bubble');

    if (itemCount <= 0) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      const visible = document.createElement('span');
      visible.setAttribute('aria-hidden', 'true');
      bubble.appendChild(visible);
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      bubble.appendChild(hidden);
      cartIcon.appendChild(bubble);
    }

    const spans = bubble.querySelectorAll('span');
    if (spans[0]) spans[0].textContent = itemCount < 100 ? String(itemCount) : '';
    if (spans[1]) spans[1].textContent = `${itemCount} items`;
  }

  async function refreshAndOpenCartDrawer() {
    const cart = await getCart();
    updateCartBubble(cart.item_count);

    const notification = document.querySelector('cart-notification');
    const clone = document.querySelector('cart-notification-clone');

    if (
      notification &&
      typeof notification.renderContents === 'function' &&
      clone &&
      typeof clone.showClone === 'function'
    ) {
      let hydratedCart = cart;

      if (typeof notification.addCompareAtPrice === 'function') {
        try {
          hydratedCart = await notification.addCompareAtPrice(cart);
        } catch (error) {
          hydratedCart = cart;
        }
      }

      notification.renderContents(
        hydratedCart.items,
        'no-sections',
        'full-cart',
        false,
        hydratedCart.total_price
      );

      requestAnimationFrame(() => clone.showClone());
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }

  async function addToCart(variantId, quantity) {

    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity }]
      })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || result.message || 'Unable to add this item.');
    }

    await refreshAndOpenCartDrawer();
  }

  document.addEventListener('click', async (event) => {
    const cardButton = event.target.closest('[data-card-quick-add]');
    if (cardButton) {
      event.preventDefault();
      event.stopPropagation();

      if (cardButton.disabled) return;

      await openDrawer(cardButton);
      return;
    }

    const option = event.target.closest('[data-vss-quickbuy-option]');
    if (option && state) {
      if (option.disabled || option.getAttribute('aria-disabled') === 'true') return;
      state.selectedIndex = Number(option.dataset.vssQuickbuyOption);
      renderPurchaseUI();
      return;
    }

    const minus = event.target.closest('[data-vss-quickbuy-minus]');
    if (minus && state && !state.isBulk) {
      if (state.quantity > 1) {
        state.quantity -= 1;
        updateSingleQuantityUI(getDrawer());
      }
      return;
    }

    const plus = event.target.closest('[data-vss-quickbuy-plus]');
    if (plus && state && !state.isBulk) {
      const maxReached = state.stockEnforced && state.quantity >= state.availableStock;
      if (!maxReached) {
        state.quantity += 1;
        updateSingleQuantityUI(getDrawer());
      }
      return;
    }

    if (event.target.closest('[data-vss-quickbuy-close]')) {
      closeDrawer();
      return;
    }

    const submit = event.target.closest('[data-vss-quickbuy-submit]');
    if (submit && state) {
      const quantity = state.isBulk
        ? state.options[state.selectedIndex].quantity
        : state.quantity;

      if (state.stockEnforced) {
        state.availableStock = await remainingStockForVariant(
          state.variantId,
          state.inventoryStock
        );
      }

      if (state.stockEnforced && quantity > state.availableStock) {
        renderPurchaseUI();
        return;
      }

      submit.disabled = true;
      submit.textContent = 'Adding…';

      try {
        await addToCart(state.variantId, quantity);
        closeDrawer();
      } catch (error) {
        console.error(error);
        submit.disabled = false;
        renderPurchaseUI();
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    const quantityInput = event.target.closest('[data-vss-quickbuy-quantity]');
    if (quantityInput && event.key === 'Enter') {
      event.preventDefault();
      quantityInput.blur();
      return;
    }

    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('input', (event) => {
    const quantityInput = event.target.closest('[data-vss-quickbuy-quantity]');
    if (!quantityInput || !state || state.isBulk) return;

    if (quantityInput.value === '') {
      const submit = getDrawer().querySelector('[data-vss-quickbuy-submit]');
      if (submit) submit.disabled = true;
      return;
    }

    state.quantity = clampSingleQuantity(quantityInput.value);
    updateSingleQuantityUI(getDrawer());
  });

  document.addEventListener('change', (event) => {
    const quantityInput = event.target.closest('[data-vss-quickbuy-quantity]');
    if (!quantityInput || !state || state.isBulk) return;

    state.quantity = clampSingleQuantity(quantityInput.value);
    updateSingleQuantityUI(getDrawer());
  });
})();

